export default {
  "OneTouchContents.Title": "かんたんおすすめ設定",
  "OneTouchContents.Caution":
    "{asterisk}サービスのご利用に必要なデータ提供や法令で認められている範囲でお客さまの同意を得る必要がない場合のデータ提供は、変更できません",
  "OneTouchContents.SummaryText":
    "データの提供先と種類について、まとめてかんたんに設定することができます。特典の提供元と種類に応じ「バリュー」「スタンダード」「ライト」から選択いただけます",
  "OneTouchContents.AgreeButton": "上記の内容に同意する",
  "OneTouchContents.BackButton": "前のページへ戻る",
  "OneTouchContents.OneTouchToAdditionalTypeLinkText":
    "「バリュー」「スタンダード」「ライト」の違いとは",
  "OneTouchContents.OneTouchToAdditionalLinkText":
    "ドコモグループ・NTTグループ・その他提携先とは",
  "OneTouchContents.OneTouchToAdditionalLink":
    "https://id-biz.smt.docomo.ne.jp/src/utility/providing_destinations.html",
  "OneTouchContents.ValueTab": "バリュー",
  "OneTouchContents.StandardTab": "スタンダード",
  "OneTouchContents.LightTab": "ライト",
  "OneTouchContents.ValueTabDescription":
    "おトクなお知らせ、ライフスタイル、ヘルスケア情報に応じた特典を受け取れます",
  "OneTouchContents.StandardTabDescription":
    "パートナーから、おトクなお知らせに加え、ライフスタイルに応じた特典を受け取れます",
  "OneTouchContents.LightTabDescription":
    "パートナーからおトクなお知らせを受け取れます",
}
